<template>
	<lazy-background :src="src" class="input-lazy-background" :class="{empty: !this.src}">
		<a href="#" @click.prevent="chooseImage"><icon icon="technology/cloud/cloud-upload"></icon></a>
		<input type="file" style="display: none;" ref="file" @change="updateSrc" accept=".png,.gif,.jpeg,.jpg" />
	</lazy-background>
</template>

<script>
	export default {
		props: ['value', 'disabled', 'label'],
		data() {
			return {
				image: this.value
			};
		},
		computed: {
			src() {
				if(!this.image) {
					return null;
				}
				if(typeof(this.image) === 'string') {
					return this.image;
				}
				if(typeof(this.image) === 'object') {
					return URL.createObjectURL(this.image);
				}
			}
		},
		watch: {
			value() {
				this.image = this.value;
			},
			image() {
				this.$emit('input', this.image);
			}
		},
		methods: {
			chooseImage() {
				if(this.disabled){
					return;
				}
				this.$refs.file.dispatchEvent(new MouseEvent('click'));
			},
			updateSrc(event) {
				if(this.disabled){
					return;
				}
				this.image = event.currentTarget.files[0];
				event.currentTarget.value = '';
			}
		}
	}
</script>